module.exports = __webpack_public_path__ + "img/location_2.400123c5.png";